<template>
<div class="main">
  <div class="main-header">
    <el-descriptions class="margin-top" :column="2" size="mini" border label-style="width: 100px;">
      <el-descriptions-item label="流程标题">
        <el-input
          style="width: 200px"
          placeholder="请输入流程标题"
          v-model="where.Description"
          clearable>
        </el-input>
      </el-descriptions-item>
      <el-descriptions-item label="流水号">
        <el-input
          style="width: 200px"
          placeholder="请输入流水号"
          v-model="where.SerialNum"
          clearable>
        </el-input>
      </el-descriptions-item>
      <el-descriptions-item label="发起日期">
        <el-date-picker
          style="width: 150px"
          v-model="where.start_time"
          size="mini"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        至
        <el-date-picker
          style="width: 150px"
          v-model="where.end_time"
          size="mini"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="流程类别">
        <el-select v-model="where.ProcessName" size="mini" placeholder="请选择" style="width: 200px">
          <el-option label="全部" value="0"></el-option>
          <el-option label="一般" value="1"></el-option>
          <el-option label="紧急" value="2"></el-option>
          <el-option label="加急" value="3"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="流程类别">
        <el-button @click="search()">搜索</el-button>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div class="main-body">
    <div class="table-wrap">
      <el-table
        :data="pageData.list"
        border
        style="width: 100%" height="60vh">
        <el-table-column
          prop="Description"
          label="标题"
          width="400">
          <template slot-scope="scope">
            <el-link @click="openOldFlow(scope.row)" type="primary">{{scope.row.Description}}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProcessName"
          label="类别"
          width="200">
        </el-table-column>
        <el-table-column
          prop="OwnerAccount"
          label="发起单位/所有人"
          width="180">
        </el-table-column>
        <el-table-column
          prop="date_time"
          sortable
          width="280"
          label="发起时间/批准时间">
          <template slot-scope="scope">
            {{scope.row.FinishAt?scope.row.FinishAt:scope.row.CreateAt}}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <!--          {{scope.row.is_finish?'已结束':'在处理'}}-->
            <el-tag v-if="scope.row.State=='Approved'" type="success">已结束</el-tag>
            <el-tag v-else type="danger">在处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="action_user_name"
          label="当前处理人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="action_node_name"
          label="当前步骤"
          width="150">
        </el-table-column>

        <el-table-column
          prop="SerialNum"
          label="流水号"
          width="150">
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
<!--            <el-button type="primary" size="mini" @click="openInfo(scope.row)">取回</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import Http from "./common/Http";
import moment from "moment/moment";

export default {
  name: "FlowOldHistory",
  data(){
    return{
      host_url:Http.getBaseURL(),
      where:{
        Description:"",
        SerialNum:"",
        start_time:moment(new Date()).format("YYYY-MM-DD"),
        end_time:moment(new Date()).format("YYYY-MM-DD"),
        ProcessName:""
      },
      pageData:{
        list:[],
        page:0,
        size:20,
        total:0
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading=true;
      let searchWhere = {...that.where};
      let where=JSON.parse(JSON.stringify(searchWhere));
      Http.get("flow/FlowOldHistory/getTaskList",{
        ...where,
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        type: this.selectType
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    openOldFlow(item){
      let v=(new Date()).getTime();
      ERP.navigateTo(`/flow/FlowOldHistoryShow?task_id=${item.TaskID}&v=${v}`);
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}
.main{
  margin: 20px 20px;
  .main-header{

  }
  .view-win{
    height: calc( 70vh - 150px );
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowOldHistory.vue